<template>
    <div :class="{app: true, mobile: mq.lgMinus}">
        <IToast />
        <div :class="{'loading-page': isLoading}">
            <slot />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { router } from '@inertiajs/vue3';
import { useMq } from 'vue3-mq';
import IToast from '@/Components/Common/IToast.vue';

const mq = useMq();
const isLoading = ref(false);

// Whether the current visit resolved into something rendered in place:
// a new page (success), validation errors (error/invalid) or an error modal
// (exception). A full-page redirect via Inertia::location (409, e.g. after a
// successful login → dashboard / OAuth redirect_uri / after 2FA) resolves into
// NONE of these — Inertia hands the browser off to window.location instead.
// In that single case we keep the wait overlay up until the browser replaces
// the document, so the previous page (the login form) never flashes back and the
// user cannot submit again while the redirect is still loading.
let handledInPlace = false;

router.on('start', () => {
    isLoading.value = true;
    handledInPlace = false;
});

['success', 'error', 'invalid', 'exception'].forEach((event) => {
    router.on(event, () => {
        handledInPlace = true;
    });
});

router.on('finish', (event) => {
    if (handledInPlace || !event.detail.visit.completed) {
        isLoading.value = false;
    }
});
</script>
